import { getColor } from "../../../common/components/Chart/utils/coloring";

/**
 * Sorts the keys of an object with date keys in ascending order (format: MM/DD/YYYY).
 * @param {Object} inputObject - The input object to be sorted.
 */
const sortObjectKeysByDate = (inputObject) => {
  const sortedKeys = Object.keys(inputObject).sort((a, b) => {
    const dateA = new Date(a.split("/").reverse().join("-"));
    const dateB = new Date(b.split("/").reverse().join("-"));
    return dateA - dateB;
  });

  const sortedObject = {};
  sortedKeys.forEach((key) => {
    sortedObject[key] = inputObject[key];
  });

  // Update the original object in place
  Object.keys(inputObject).forEach((key) => {
    delete inputObject[key];
  });
  Object.assign(inputObject, sortedObject);
};


function generate_aging_histogram_data(data, buckets,) {
  if (data.age < 25) {
    buckets.below_25++;
  }
  else if (data.age >= 25 && data.age < 50) {
    buckets["25_to_50"]++;
  }
  else if (data.age >= 50 && data.age < 75) {
    buckets["50_to_75"]++;
  }
  else if (data.age >= 75 && data.age < 100) {
    buckets["75_to_100"]++;
  }
  else if (data.age >= 100 && data.age < 125) {
    buckets["100_to_125"]++;
  }
  else if (data.age >= 125 && data.age < 150) {
    buckets["125_to_150"]++;
  }
  else if (data.age >= 150 && data.age < 175) {
    buckets["150_to_175"]++;
  }
  else {
    buckets["above_175"]++;
  }
}

function check_and_generate_aging_histogram_data(data, buckets, selected_status, filtered_table_by_sample_status) {
  if (!selected_status || selected_status === "total_sample") {
    generate_aging_histogram_data(data, buckets);
    // filtered_table_by_sample_status.push(data);
  }
  else if (selected_status === "ongoing_sample" && data.remarks !== "Completed") {
    generate_aging_histogram_data(data, buckets);
    filtered_table_by_sample_status.push(data);
  }
  else {
    switch (data.remarks) {
      case "Completed": {
        if (selected_status === "completed_sample") {
          generate_aging_histogram_data(data, buckets);
          filtered_table_by_sample_status.push(data);
        }
        break;
      }
      case "Review": {
        if (selected_status === "under_review") {
          generate_aging_histogram_data(data, buckets);
          filtered_table_by_sample_status.push(data);
        }
        break;
      }
      case "OOS": {
        if (selected_status === "OOS_investigation") {
          generate_aging_histogram_data(data, buckets);
          filtered_table_by_sample_status.push(data);
        }
        break;
      }
      case "OOT": {
        if (selected_status === "OOT_investigation") {
          generate_aging_histogram_data(data, buckets);
          filtered_table_by_sample_status.push(data);
        }
        break;
      }
      case "Deviation": {
        if (selected_status === "deviation") {
          generate_aging_histogram_data(data, buckets);
          filtered_table_by_sample_status.push(data);
        }
        break;
      }
      default:
        break;
    }
  }
}

export const perform_analysis_on_backlog_data = (table_data, selected_status) => {
  // console.log({ table_data_for_analysis: table_data });
  const buckets = {
    "below_25": 0,
    "25_to_50": 0,
    "50_to_75": 0,
    "75_to_100": 0,
    "100_to_125": 0,
    "125_to_150": 0,
    "150_to_175": 0,
    "above_175": 0,
  };

  const filtered_table_by_sample_status = [];

  const sample_status = {
    total_sample: 0,
    pending: 0,
    // under_test: 0,
    qc_testing_completed: 0,
    under_review: 0,
    awaiting_approval: 0,
    OOS: 0,
    OOT: 0,
    deviation: 0,
    lab_event: 0,
    under_ud_by_qa: 0,
    ud_approved: 0,
    "Conditional Release": 0,
    "On Hold": 0,
  };

  const daywise_completion_rate = {};
  const daywise_sampling_receive_rate = {};

  // const filtered_data = table_data.filter()

  for (let data of table_data) {
    // if (data["completion_date"]) {
    //   const completion_date_value = data["completion_date"];
    //   if (daywise_completion_rate[completion_date_value]) {
    //     daywise_completion_rate[completion_date_value]++;
    //   }
    //   else {
    //     daywise_completion_rate[completion_date_value] = 1;
    //   }
    // }
    // if (data["due_date"]) {
    //   const due_date_value = data["due_date"];
    //   if (daywise_sampling_receive_rate[due_date_value]) {
    //     daywise_sampling_receive_rate[due_date_value]++;
    //   }
    //   else {
    //     daywise_sampling_receive_rate[due_date_value] = 1;
    //   }
    // }
    sample_status.total_sample++;
    switch (data.remark) {
      case "Completed": {
        sample_status.qc_testing_completed++;
        break;
      }
      case "Awaiting Approval": {
        sample_status.qc_testing_completed++;
        sample_status.awaiting_approval++;
        break;
      }
      case "Under UD": {
        sample_status.qc_testing_completed++;
        sample_status.under_ud_by_qa++;
        break;
      }
      case "QC Testing Completed": {
        sample_status.qc_testing_completed++;
        break;
      }
      case "Review": {
        sample_status.qc_testing_completed++;
        sample_status.under_review++;
        break;
      }
      case "Under Review": {
        sample_status.under_review++;
        break;
      }
      case "OOS": {
        sample_status.OOS++;
        break;
      }
      case "OOT": {
        sample_status.OOT++;
        break;
      }
      case "Deviation": {
        sample_status.deviation++;
        break;
      }
      case "Lab Event": {
        sample_status.lab_event++;
        break;
      }
      case "Under Test": {
        sample_status.under_test++;
        break;
      }
      case "UD Approved": {
        sample_status.ud_approved++;
        break;
      }
      default:
        if (sample_status?.[data.remark] || sample_status?.[data.remark] === 0) {
          sample_status[data.remark] = sample_status?.[data.remark] + 1;
        }
        else {
          sample_status.pending++;
        }
        break;
    }
    check_and_generate_aging_histogram_data(data, buckets, selected_status, filtered_table_by_sample_status);
    // if (data.age) {
    //   // console.log({ data });
    // }
  }
  // console.log({ filtered_table_by_sample_status });
  // console.log(daywise_completion_rate);
  // console.log(sample_status);
  // sample_status.ongoing_sample = sample_status.total_sample - sample_status.completed_sample - sample_status.under_review;
  const aging_histogram = {
    series: Object.values(buckets),
    categories: Object.keys(buckets),
    colors: Object.keys(buckets).map(item => getColor("", item))
  };

  sortObjectKeysByDate(daywise_completion_rate);

  const daywise_completion_rate_histogram = {
    series: Object.values(daywise_completion_rate),
    categories: Object.keys(daywise_completion_rate),
    colors: ["#2B4162"]
  };

  sortObjectKeysByDate(daywise_sampling_receive_rate);
  const daywise_sampling_receive_rate_histogram = {
    series: Object.values(daywise_sampling_receive_rate),
    categories: Object.keys(daywise_sampling_receive_rate),
    colors: ["#2B4162"]
  };
  // console.log({ buckets });
  // const expiry_bar_chart = {}
  return { aging_histogram, sample_status, daywise_completion_rate_histogram, daywise_sampling_receive_rate_histogram, filtered_table_by_sample_status };
};